import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {ClientDtoModel} from '../models/client.dto.model';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/clients`;
    }

    public getAllClients(name: string): Observable<ClientDtoModel[]> {
        return this.http.get<ClientDtoModel[]>(`${this.baseUrl}${`?name=${name || ''}`}`);
    }

    public getClientByUuid(uuid: String): Observable<ClientDtoModel> {
        return this.http.get<ClientDtoModel>(`${this.baseUrl}` + '/uuid/' + uuid);
    }

    public updateClient(clientDTO: ClientDtoModel): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/`, clientDTO);
    }

    public addNewClient(newClient: ClientDtoModel): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/`, newClient);
    }
}
